import { render, staticRenderFns } from "./ExternalIdentities.vue?vue&type=template&id=f3c80878&"
import script from "./ExternalIdentities.vue?vue&type=script&lang=js&"
export * from "./ExternalIdentities.vue?vue&type=script&lang=js&"
import style0 from "./ExternalIdentities.vue?vue&type=style&index=0&id=f3c80878&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports